export default __webpack_public_path__ + "assets/bullet.6373aa5b.svg";